<template>
  <div class="sidebar-link mb-2">
    <router-link v-if="link" :to="{ path: link }" class="h5 flex-fill"><b-icon :icon="icon" class="mr-3"></b-icon>{{title}}</router-link>
    <a v-else :href="href" class="h5 flex-fill"><b-icon :icon="icon" class="mr-3"></b-icon>{{title}}</a>
  </div>
</template>

<script>
export default {
  name: 'SidebarLink',
  props: {
    title: String,
    icon: String,
    link: String,
    href: String
  }
}
</script>